import { SET_DATE_RANGE, SET_TIME_RANGE, AUTO_UPDATE_DATE } from "../actions/dateTimeActions";
import dayjs from "dayjs";
import { getTodayInTz } from "../../utils/dateUtils";

const getDefaultDateRange = () => {
  const today = getTodayInTz();
  return {
    startDate: dayjs(today).subtract(7, 'day').format('YYYY-MM-DD'),
    endDate: today,
  };
};

const getInitialDateRange = (() => {
  const stored = sessionStorage.getItem('dateRange');
  sessionStorage.removeItem('dateRange');
  const result = stored ? JSON.parse(stored) : getDefaultDateRange();
  return result;
})();

const initialState = {
  dateRange: getInitialDateRange,
  timeRange: {
    startTime: '00:00',
    endTime: '23:59',
  },
};

const datetimeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATE_RANGE:
      return { ...state, dateRange: action.payload };

    case SET_TIME_RANGE:
      return { ...state, timeRange: action.payload };

    case AUTO_UPDATE_DATE:
      const newDate = new Date().toISOString().split("T")[0];
      return { ...state, dateRange: { startDate: newDate, endDate: newDate } };

    default:
      return state;
  }
}

export default datetimeReducer